export type GrowSectionStatisticItem = {
  id: string
  number: number
  caption: string
}

export const GROW_SECTION_STATISTIC_ITEMS: GrowSectionStatisticItem[] = [
  {
    id: 'GrowSectionStatisticItem-001',
    number: 94,
    caption: 'Members are\nC-SUITE/Owners',
  },
  {
    id: 'GrowSectionStatisticItem-002',
    number: 73,
    caption: 'Professional\nServices',
  },
  {
    id: 'GrowSectionStatisticItem-003',
    number: 71,
    caption: 'Procure EMAJIN\nmember services',
  },
  {
    id: 'GrowSectionStatisticItem-004',
    number: 10,
    caption: 'Profits support\ncharity',
  },
]
